<template>
  <div class="view-course-page">
    <header class="course-header">
      <h1>{{course.name }}</h1>
    </header>

    <div class="unavailable" v-if="course && course.module && !course.module.length">
      <h2>Course Modules are not available</h2>
    </div>
    <div class="course-content" v-if="course && course.module && course.module.length">
      <!-- Sidebar Navigation -->
      <aside class="sidebar">
        <ul class="modules">
          <li class="module" v-for="(courseMod, index) in course.module" :key="index">
            <div class="module-header" @click="toggleModule(index)">
              <span>{{courseMod.sequence}}. {{ courseMod.name }}</span>
              <span>{{ courseMod.progress || 0 }}/{{ courseMod.lesson.length }}</span>
            </div>
            <ul
              class="lessons"
              v-show="activeModule === index"
            >
              <li
                v-for="(lesson, idx) in courseMod.lesson"
                :key="idx"
                @click="selectLesson(courseMod.name, lesson, (index+1)+'.'+(idx+1) )"
                :class="{ active: currentLesson.name === lesson.name }"
              >
                <span>{{index+1}}.{{idx+1}} {{ lesson.name }}</span>
                <span class="duration">{{ lesson.duration }} minutes</span>
              </li>
            </ul>
          </li>
        </ul>
      </aside>

      <!-- Main Content -->
      <div class="lesson-view" v-if="currentLesson.name">
        <h2>{{ selectedIdx }}. {{ currentLesson.name }}</h2>
        <div class="video-section">
          <div class="video-container" v-if="currentLesson.lesson_link">
            <!-- <youtube :video-id="computedVideoUrl(currentLesson.lesson_link)" ref="youtube" @playing="playing"></youtube> -->
              <iframe :src="currentLesson.lesson_link + '?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media">
              </iframe>
          </div>
          <!-- <div class="video-container" v-if="videoData">
            <iframe
              :src="videoData.embed_url"
              width="640"
              height="360"
              frameborder="0"
              allow="autoplay; fullscreen"
              allowfullscreen
            ></iframe>
          </div> -->
        </div>
        <p class="lesson-description" v-html="format(currentLesson.description)">
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      accessToken: null,
      videoData: null,
      videoId: '',
      selectedIdx: 1.1,
      courseModules: [
        {
          title: "Introduction to blockchain basics",
          progress: 0,
          totalLessons: 1,
          lessons: [
            { title: "Overview of the blockchain", duration: "20 minutes" },
          ],
        },
        {
          title: "Smart Contract",
          progress: 0,
          totalLessons: 4,
          lessons: [
            { title: "Smart Contract Basics", duration: "15 minutes" },
            { title: "Smart Contract Examples", duration: "20 minutes" },
            { title: "Deploying Contracts", duration: "25 minutes" },
            { title: "Security Practices", duration: "30 minutes" },
          ],
        },
        {
          title: "Trading basics",
          progress: 0,
          totalLessons: 6,
          lessons: [
            { title: "Trading Fundamentals", duration: "10 minutes" },
            { title: "Crypto Exchanges", duration: "15 minutes" },
            { title: "Trading Tools", duration: "20 minutes" },
            { title: "Analyzing Markets", duration: "25 minutes" },
            { title: "Risk Management", duration: "30 minutes" },
            { title: "Advanced Techniques", duration: "40 minutes" },
          ],
        },
      ],
      activeModule: null,
      currentModule: "Introduction to blockchain basics",
      currentLesson: {},
      course: {}
    };
  },
  async mounted() {
    this.getCourseDetail();
    if (this.$route.name === "FreeCourse") {
      this.submitPaymentDetails();
    }
  },
  methods: {
    async submitPaymentDetails() {
      const currentDate = new Date();
      const formattedDate =
        currentDate.getFullYear() +
        "-" +
        String(currentDate.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(currentDate.getDate()).padStart(2, "0");
      try {
        const formData = new FormData();
        formData.append('course_id', this.$route.params.id);
        formData.append('start_date', formattedDate);
        await axios.post("user/enrollment", formData);
      } catch (err) {
        console.log(err);
      }
    },
    async getAccessToken() {
      try {
        const CLIENT_ID = '';
        const CLIENT_SECRET = '';

        const response = await axios.post('https://api.dailymotion.com/oauth/token', {
          client_id: CLIENT_ID,
          client_secret: CLIENT_SECRET,
          grant_type: 'client_credentials',
        }, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            }
        })
        this.accessToken = response.data.access_token;
      } catch (error) {
        console.error('Error getting access token:', error);
      }
    },
    async getVideoData() {
      if (!this.accessToken) return;

      try {
        const response = await fetch(
          `https://api.dailymotion.com/video/${this.videoId}?fields=embed_url?password=123456789`, 
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${this.accessToken}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        this.videoData = data;
      } catch (error) {
        console.error('Error fetching video data:', error);
      }
    },

    format(val) {
      return val.replace(/\r\n|\n/g, '<br>');
    },
    playVideo() {
      this.player.playVideo();
    },
    playing() {
      console.log('we are watching!!!')
    },
    computedVideoUrl(link) {
      return this.$youtube.getIdFromUrl(link)
    },
    async getCourseDetail() {
      try {
        const response = await axios.get("courses/view/"+this.$route.params.id);
        this.course = response.data.data;
        if (this.course.module.length) {
          this.toggleModule(0);
          setTimeout(()=> {
            if (this.course.module[0].lesson.length) {
              const lesson = this.course.module[0].lesson[0];
              this.selectLesson(this.course.module[0].name, lesson, '1.1')
            }
          })
          
        }
      } catch (err) {
        console.log(err);
      }
    },
    toggleModule(index) {
      this.activeModule = this.activeModule === index ? null : index;
    },
    selectLesson(moduleTitle, lesson, idx) {
      this.currentModule = moduleTitle;
      this.currentLesson = lesson;
      this.selectedIdx = idx;
    },
  },
};
</script>

<style scoped>
/* General Styling */
.view-course-page {
  font-family: Arial, sans-serif;
  font-family: 'GothicB';
}
.course-header {
  text-align: center;
  background-color: #0e1332;
  color: #fff;
  padding: 3rem 0;
}
.course-content {
  display: flex;
  gap: 1rem;
}

/* Sidebar */
.sidebar {
  flex: 1;
  max-width: 25%;
  border-right: 1px solid #ddd;
  padding: 1rem;
}
.modules {
  list-style: none;
  margin: 0;
  padding: 0;
}
.module {
  margin-bottom: 1rem;
}
.module-header {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  cursor: pointer;
  padding: 0.5rem 0;
  border-bottom: 1px solid #ddd;
}
.lessons {
  list-style: none;
  padding: 0.5rem 1rem;
  margin: 0;
}
.lessons li {
  padding: 0.5rem 0;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9rem;
}
.lessons li.active {
  font-weight: bold;
  color: #F1B97D;
}
.duration {
  font-size: 0.8rem;
  color: #666;
}

/* Lesson View */
.lesson-view {
  flex: 3;
  padding: 1rem;
}
.lesson-view h2 {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.video-section {
  margin-bottom: 1rem;
}
.video-placeholder {
  width: 100%;
  height: 300px;
  border: 1px solid #ddd;
  background-color: #f0f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  color: #999;
}
.lesson-description {
  font-size: 0.9rem;
  word-break: break-word;
  line-height: 1.6;
}

.unavailable {
  padding-top: 2rem;
  display: flex;
  justify-content: center;
}

.video-container {
  position: relative;
  height: 550px;
  overflow: hidden;
  max-width: 100%;
  background-color: black;
}

::v-deep iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* Responsive Design */
@media (max-width: 768px) {
  .sidebar {
    max-width: 100%;
  }
  .course-content {
    flex-direction: column;
  }
  .lesson-view {
    padding: 0.5rem;
  }
  .video-placeholder {
    height: 200px;
  }
}
@media (max-width: 480px) {
  .course-header {
    font-size: 1rem;
    padding: 1rem 0;
  }
  .module-header {
    font-size: 1.2rem;
  }
  .video-placeholder {
    height: 150px;
  }
  .lesson-description {
    font-size: 1.1rem;
  }
}
</style>
